import React from 'react';
import { MessageCircle } from 'lucide-react';
import './WhatsAppButton.css';

export const WhatsAppButton = () => {
  const phoneNumber = '918826372788';
  const message = encodeURIComponent("Hi! I'd like to enquire about dates and packages at The Green Valley.");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle size={28} />
    </a>
  );
};

export default WhatsAppButton;
